import { render, staticRenderFns } from "./batchReport.vue?vue&type=template&id=17756182&scoped=true"
import script from "./batchReport.vue?vue&type=script&lang=js"
export * from "./batchReport.vue?vue&type=script&lang=js"
import style0 from "./batchReport.vue?vue&type=style&index=0&id=17756182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17756182",
  null
  
)

export default component.exports